import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';
import * as moment from 'moment';

export class Custodian extends DrEntity {

    static priorityNotSelected = 32767;
    static defaultPriorityModal = '1';

    name: string;
    description: string;
    documentCount: number;
    dateCreated: string;
    emailAddresses: Array<any>;
    priority: number;
    userIds: Array<any>;
    archived: boolean;

    // off-model display values
    priorityDisplay: string;
    priorityModal: string;
    iconClass: string;
    iconColor: string;
    priorityEnabled: boolean;

    constructor(value?: Partial<Custodian>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
        if (!this.priority) {
            this.priority = 0;
        }
        this.priorityDisplay = (this.priority === 0 || this.priority === Custodian.priorityNotSelected) ? 'None' : this.priority.toString();
        this.iconClass = this.name === 'Unassigned' ? 'fa-user-circle' : 'fa-user-circle-o';
        this.iconColor = this.name === 'Unassigned' ? 'color-grey-08' : 'color-blue-01';
        this.priorityModal = (this.priority === 0 || this.priority === Custodian.priorityNotSelected) ? Custodian.defaultPriorityModal : this.priority.toString();
        this.priorityEnabled = (this.priority !== 0) && (this.priority !== Custodian.priorityNotSelected);
        if (this.dateCreated) {
            const date = moment(this.dateCreated);
            this.dateCreated = date.format('YYYY-MM-DD hh:mm:ss');
        }
    }

    togglePriorityEnabled(): void {
        if (!this.priorityEnabled) {
            this.priority = Custodian.priorityNotSelected;
        } else {
            this.priority = Number(this.priorityModal);
        }

        this.priorityModal = (this.priority === 0 || this.priority === Custodian.priorityNotSelected) ? Custodian.defaultPriorityModal : this.priority.toString();
        this.priorityEnabled = (this.priority !== 0) && (this.priority !== Custodian.priorityNotSelected);
    }

    updatePriority(): void {
        this.priority = Number(this.priorityModal);
    }

}

export class CustodianViewModel extends DrObject {
    model: Partial<Custodian>;
    original: Partial<Custodian>;

    constructor(value?: Partial<Custodian>) {
        super(DrObjectType.CUSTODIAN, SupportedRegExType.METADATAVIEW);

        if (value) {
            this.model = value;
        }

        if (this.model) {
            this.original = new Custodian(this.model);
        }
    }

    isDirty(): boolean {
        let isDirty = false;
        if (this.original.priorityModal !== this.model.priorityModal) {
            isDirty = true;
        }
        return isDirty;
    }
}
